module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Heart-894d8b9e0276e3c881706d861ea505bc57efe9b6c863d7ccac7fa1c16dbbe7ec.svg";